import './Error.css';

const FlagContainer = ({ backgroundColor, color, content }) => {
  return (
    <div className="flag-container" style={{ backgroundColor, color }}>
        {content}
    </div>
  );
};

export default FlagContainer;